import { getFallbackPreview } from "../constants/widget-templates";
import type { WidgetTemplateListItem } from "../types";

interface WidgetTemplateSelectorProps {
	selectedTemplate: WidgetTemplateListItem | null;
	selectedTemplateName: string | null;
	onClick: () => void;
}

export default function WidgetTemplateSelector({ selectedTemplate, selectedTemplateName, onClick }: WidgetTemplateSelectorProps) {
	const label = selectedTemplate?.label || selectedTemplateName || "Select a template";
	const description = selectedTemplate?.description || "Click to choose a widget template";
	const previewImageUrl = selectedTemplate?.preview_image_url;
	const fallbackPreview = selectedTemplateName ? getFallbackPreview(selectedTemplateName) : null;

	return (
		<button
			type="button"
			onClick={onClick}
			className="w-full rounded-xl border border-gray-200 text-left transition-all hover:border-gray-300 hover:bg-gray-50 overflow-hidden"
		>
			<div className="flex flex-row items-stretch">
				<div className="w-1/2 shrink-0">
					{previewImageUrl ? (
						<div className="h-40 w-full bg-gray-50 overflow-hidden">
							<img src={previewImageUrl} alt={label} className="w-full h-full object-cover" />
						</div>
					) : fallbackPreview ? (
						<>{fallbackPreview}</>
					) : (
						<div className="h-40 w-full bg-gray-50 flex items-center justify-center">
							<span className="text-xs text-gray-400">Preview</span>
						</div>
					)}
				</div>
				<div className="w-1/2 p-4 flex flex-col justify-between border-l border-gray-200">
					<div>
						<h4 className="text-sm font-semibold text-gray-900 mb-1">{label}</h4>
						<p className="text-xs text-tertiary">{description}</p>
					</div>
					<span className="text-sm font-medium text-gray-600 flex items-center gap-1">
						Change template
						<svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
						</svg>
					</span>
				</div>
			</div>
		</button>
	);
}
